module.exports = __webpack_public_path__ + "img/attachment.1f061d42.png";